<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <div>
        <span class="border-l-2 border-blue-500 pl-10px text-16px mb-20px">查看计划情况</span>
      </div>
      <div class="text-18px ml-20px mt-30px">基本培训信息</div>
      <div class="flex-1 overflow-y-auto pr-100px mt-20px">
        <el-form :model="formData" ref="formRef" label-width="150px" disabled>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训名称')}`" prop="name">
                <el-input
                  v-model="formData.name"
                  :placeholder="`${$t('请输入')}`"
                  :maxlength="30"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训类型')}`" prop="trainingType">
                <el-select
                  v-model="formData.trainingType"
                  size="small"
                  :placeholder="`${$t('培训类型')}`"
                  clearable
                  class="w-full"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in trainingType"
                    :key="index"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="`${$t('合格学时')}`" prop="qualifiedCreditHours">
                <el-input
                  v-model="formData.qualifiedCreditHours"
                  :placeholder="`${$t('请输入')}`"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('合格学分')}`" prop="qualifiedCredits">
                <el-input
                  v-model="formData.qualifiedCredits"
                  :placeholder="`${$t('请输入')}`"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  @blur="formData.qualifiedCredits = $event.target.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('考试计划关联')}`" prop="violationTime">
                <el-input />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('发起人')}`" prop="publisherId">
                <person-singer-select
                  v-model="formData.publisherId"
                  @sentData="changePersonSelect"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训期限')}`" prop="trainingDate">
                <el-date-picker
                  type="daterange"
                  range-separator="至"
                  v-model="formData.trainingDate"
                  clearable
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('提醒时间')}`" prop="reminderTime">
                <el-date-picker
                  v-model="formData.reminderTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width:100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训课件')}`" prop="coursewares">
                <el-select
                  v-model="formData.coursewares"
                  size="small"
                  class="w-full"
                  :placeholder="`${$t('请输入')}`"
                  clearable
                  multiple
                  filterable
                  collapse-tags
                  @change="courseHandle"
                >
                  <el-option
                    v-for="(item, index) in courseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="text-18px ml-20px">培训记录</div>
        <div class="ml-40px pl-40px mt-20px">
          <el-table :data="tableList" border class="w-full" stripe>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column
              label="所属部门"
              prop="orgUnitName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="参与人" prop="userName" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="是否完成培训"
              prop="isFinished"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="课件累计学时" prop="questions" show-overflow-tooltip>
              <template>
                <span>{{ originData.coursewareTimes | showText('second') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="已完成学时" prop="finishTimes">
              <template slot-scope="scope">
                <span>{{ scope.row.finishTimes | showText('second') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="课件包含学分" prop="credit">
              <template>
                <span>{{ originData.coursewareCredits }}</span>
              </template>
            </el-table-column>
            <el-table-column label="已获取学分" prop="finishCredits"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="flex justify-center mt-20px">
        <el-button size="small" @click="dialogVisible = false" :loading="loading">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { TrainingPlanApi } from '@wiz-api/training-management'
import dayjs from 'dayjs'
import { formatSeconds } from '../EnumField'

const PersonSingerSelect = () => {
  return import('@/components/safety/FormSelect/PersonSelect')
}

const trainingPlanApi = new TrainingPlanApi()
export default {
  name: 'train-person-detail',
  components: { PersonSingerSelect },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'second') {
        result = val && formatSeconds(val)
      }
      return result
    },
  },
  props: {
    operateType: {
      default: '',
      type: String,
    },
    operateData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    trainingType: {
      type: Array,
      default: () => {
        return []
      },
    },
    courseList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      formData: {
        name: '',
        trainingType: '',
        qualifiedCredits: undefined,
        examId: null,
        examName: null,
        publisherId: '',
        publisherName: '',
        trainingDate: '',
        reminderTime: '',
        qualifiedCreditHours: undefined,
        notice: '',
        coursewares: [],
        persons: '',
      },
      originData: {},
      tableList: [],
      fileList: [],
      loading: false,
      showSelectDialog: false,
      personList: [],
      pageTitle: '',
    }
  },
  mounted() {
    this.initInfoData()
  },

  methods: {
    // 合计
    getSummary(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[0] = '合计'
        }
        if ([2, 3, 4, 6].includes(index)) {
          sums[index] = data.reduce((pre, cur) => {
            pre += cur[column.property] || 0
            return pre
          }, 0)
          if (index === 2) {
            sums[index] = formatSeconds(sums[index])
          }
        }
      })
      return sums
    },
    // 详情
    async initInfoData() {
      const [err, res] = await trainingPlanApi.getPlan({ id: this.operateData.id })
      if (err) return
      this.originData = res
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = res[key]
      })
      this.formData.trainingDate = [res.trainingDateStart, res.trainingDateEnd]
      this.formData.qualifiedCreditHours = formatSeconds(res.qualifiedCreditHours)

      // 课件处理
      const coursewaresId = res.coursewares.map((item) => {
        return item.coursewareId
      })
      this.formData.coursewares = coursewaresId
      this.tableList = res.persons

      // 人员处理
      const persons = res.persons.map((item) => {
        const val = {
          id: item.userId,
          name: item.userName,
          organizationUnitName: item.orgUnitName,
          organizationUnitId: item.orgUnitId,
          keyId: item.keyId,
        }
        return val
      })
      this.getPersonList(persons)
    },
    // 课件处理
    courseHandle() {
      if (this.formData.coursewares.length) {
        let data = this.courseList.filter((item) => {
          return this.formData.coursewares.includes(item.id)
        })
        data = _.cloneDeep(data)
        data.forEach((item) => {
          item.isCompulsory = false
          item.credit = 1
        })
        this.tableList = data
      } else {
        this.tableList = []
      }
    },
    // 返回选择人员的id
    changePersonSelect(data) {
      this.formData.publisherName = data.name
    },
    getPersonList(personList) {
      this.personList = personList.map((item) => {
        return {
          userName: item.name,
          name: item.name,
          userId: item.id,
          keyId: item.keyId,
          orgUnitName: item.organizationUnitName,
          orgUnitId: item.organizationUnitId,
        }
      })
      this.formData.persons = this.personList.reduce((pre, cur, index) => {
        pre += cur.name + (index === this.personList.length - 1 ? '' : ',')
        return pre
      }, '')
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
